import React, { useState } from 'react';
import PromoComponent from './PromoComponent';
import VideosComponent from './VideosComponent';

const MediaPage = () => {
  const [showMedia, setShowMedia] = useState(1);
  return (
    <div className="center-container">
      <div className="d-flex justify-content-around media-navigation">
        <label
          className={`media-navigation-label ${showMedia === 1 &&
            ' active-media'}`}
          onClick={() => setShowMedia(1)}
        >
          VMC Promo
        </label>
        <label
          className={`media-navigation-label ${showMedia === 2 &&
            ' active-media'}`}
          onClick={() => setShowMedia(2)}
        >
          Video Galerija
        </label>
      </div>
      {showMedia === 1 && <PromoComponent></PromoComponent>}
      {showMedia === 2 && <VideosComponent></VideosComponent>}
    </div>
  );
};

export default MediaPage;
